import React, { useState } from 'react';
import { css } from '@emotion/react';

import { hexToRgbaString, white } from 'styles/global_defaults/colors';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';

import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import ClickableContainer from 'components/clickable-container';
import { Placement } from 'react-bootstrap/esm/Overlay';

type TopPanelActionButtonProps = {
  icon?: string;
  tooltipText: string;
  onClick?: () => void;
  className?: string;
  dataQa?: string,
  customIcon?: React.ReactNode;
  useDefaultStyle?: boolean;
  iconClassName?: string;
  disabled?: boolean;
  tooltipPlacement?: Placement;
  ariaLabel?: string;
};

const TopPanelActionButton = React.forwardRef<HTMLDivElement, TopPanelActionButtonProps>((props, ref) => {
  const {
    icon,
    tooltipText,
    onClick,
    className = '',
    dataQa,
    customIcon,
    useDefaultStyle = true,
    iconClassName = 'text-white',
    disabled = false,
    tooltipPlacement = 'bottom',
    ariaLabel,
  } = props;
  const styles = css`
    .edit-menu-icon-styles {
      width: ${doubleSpacing}px;
      height: ${doubleSpacing}px;
      border-radius: 50%;
      background-color: ${hexToRgbaString(white, 0.2)};

      &:hover {
        background-color: ${hexToRgbaString(white, 0.4)};
        cursor: pointer;
      }
    }
    .disabled-button {
      background-color: ${hexToRgbaString(white, 0.1)};
      cursor: not-allowed;

      &:hover {
        background-color: ${hexToRgbaString(white, 0.1)};
      }
    }
  `;

  const [showTooltip, setShowTooltip] = useState(false);

  const finalClass = `
    ${useDefaultStyle ? 'edit-menu-icon-styles mr-4' : ''}
    align-items-center justify-content-center
    ${className}
    ${disabled ? 'disabled-button' : ''}
  `;

  const finalIconClass = disabled ? 'text-gray-3' : iconClassName;

  return (
    <div css={styles}>
      <NvTooltip show={showTooltip} placement={tooltipPlacement} preventOverflow={false} text={tooltipText}>
        <ClickableContainer
          ref={ref}
          className={finalClass}
          onClick={!disabled ? onClick : undefined}
          data-qa={dataQa}
          aria-label={ariaLabel}
          disabled={disabled}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onFocus={() => setShowTooltip(true)}
          onBlur={() => setShowTooltip(false)}
        >
          {icon ? (
            <NvIcon icon={icon} size='small' className={finalIconClass} />
          ) : (
            customIcon
          )}
        </ClickableContainer>
      </NvTooltip>
    </div>
  );
});

export default TopPanelActionButton;
